module.exports = __webpack_public_path__ + "img/BOWTIE 2 GREEN.255dbd1.svg";